@import (reference) '../../../../constants/spacing.module.less';

.modal-body {
  display: flex;
  padding: @space-16;
  flex-direction: column;
  align-items: flex-start;
  gap: @space-16;
}

.order-source-counts-container {
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.max-order-sources {
  flex: 1;
}

.current-count-container {
  align-items: center;
  gap: @space-8;
  flex: 1;
}

.error-icon {
  width: 16px;
  color: var(--error--icon--fill-color--1);
}

.success-icon {
  width: 16px;
  color: var(--green-10844C);
}
